import http from '@/config/http'

export default {

  async send(method, url, data, config) {
    let params = {}
    if (!data) data = {}
    if (!config) config = {}
    if (['get','delete'].indexOf(method) >= 0) {
      params = data
      data = {}
    }
    if (window.BASE_URL && url.search('http') === -1) {
      url = window.BASE_URL + url
    }
    try {
      let res = await http.request({
        url,
        method,
        params,
        data,
        config
      })
      if (res && res.data) {
        return res.data
      } else {
        if(res.data === false){
          return res.data
        }else{
          return res
        }

      }
    } catch (e) {

      return  Promise.reject(e);
    }
  },
  // 为搜索条件附后上 search_after
}
